import { useEffect, useState } from 'react';

import { connect, useDispatch } from 'react-redux';
import { setPropDataObject, fetchInvoice } from '@redux/ducks/invoice';

import { Modal, Tabs } from '@components';
import { Load } from '@components';

import Detail from './Detail';
import Historic from './Historic';
import { QRCode } from './QRCode';
import DetailExpense from './DetailExpense';
import { DetailReturn } from './DetailReturn';
import DetailIncident from './DetailIncident';
import DetailReversal from './DetailReversal';
import { DetailDelivery } from './DetailDelivery';

const InvoiceDetail = ({ dataObject, isFetchInvoice, onTerminate }) => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState('Detalhamento');

  const { key: invoiceKey, invoice, open } = dataObject;

  const close = () => {
    dispatch(
      setPropDataObject({
        open: false,
        key: null,
        invoice: {},
      })
    );
    setSelectedTab('Detalhamento');
  };

  const noContentFound = message => {
    return (
      <div className="mt-6 flex justify-center items-center bg-orange-100 py-2 text-gray-700 text-sm font-semibold rounded-md">
        {message}
      </div>
    );
  };

  const renderPanel = panel => {
    switch (panel) {
      case 'Detalhamento':
        if (invoiceKey) {
          return <Detail source={invoice} />;
        }
        return null;

      case 'Histórico':
        return <Historic source={invoice} invoiceKey={invoice.key} />;

      case 'Entregas':
        if (invoice.deliveries) {
          return (
            <DetailDelivery
              source={invoice.deliveries}
              invoiceKey={invoice.key}
            />
          );
        }
        return null;

      case 'Devolução':
        if (invoice.reversal) {
          return (
            <DetailReversal
              source={invoice.reversal}
              close={() => dispatch(fetchInvoice(invoice.key))}
            />
          );
        }
        return null;

      case 'QR Code da nota':
        return (
          <div className="p-3">
            <QRCode value={invoice.key} />
          </div>
        );

      case 'Despesas':
        if (invoice.expenses) {
          return (
            <DetailExpense
              source={invoice.expenses}
              invoiceKey={invoice.key}
              invoiceId={invoice.id}
              onTerminate={invoiceKey => {
                dispatch(fetchInvoice(invoiceKey));
                if (onTerminate) onTerminate();
              }}
            />
          );
        }
        return noContentFound('Nenhuma despesa cadastrada');

      case 'Rejeição':
        if (invoice.return) {
          return (
            <DetailReturn
              source={invoice}
              close={() => dispatch(fetchInvoice(invoice.key))}
            />
          );
        }
        return null;

      case 'Incidentes':
        if (invoice.incidents) {
          return (
            <DetailIncident
              source={invoice.incidents}
              invoiceKey={invoice.key}
              onTerminate={invoiceKey => {
                dispatch(fetchInvoice(invoiceKey));
                if (onTerminate) onTerminate();
              }}
            />
          );
        }
        return null;

      default:
        return null;
    }
  };

  useEffect(() => {
    if (dataObject.key) {
      dispatch(fetchInvoice(dataObject.key));
    }
  }, [dataObject.key]);

  if (!invoice) {
    return null;
  }

  return (
    <>
      <Modal
        onClose={() => close()}
        open={open}
        title="Detalhamento da nota"
        containerClassSize="max-w-full"
      >
        <div className="col-span-2">
          <Tabs>
            <Tabs.Item
              name="detail"
              active={selectedTab === 'Detalhamento'}
              onClick={() => setSelectedTab('Detalhamento')}
            >
              Detalhamento
            </Tabs.Item>
            <Tabs.Item
              name="history"
              active={selectedTab === 'Histórico'}
              onClick={() => setSelectedTab('Histórico')}
            >
              Histórico
            </Tabs.Item>
            {invoice.deliveries && invoice.deliveries.length > 0 && (
              <Tabs.Item
                name="deliveries"
                active={selectedTab === 'Entregas'}
                onClick={() => setSelectedTab('Entregas')}
              >
                Entregas
              </Tabs.Item>
            )}
            {invoice.reversal && (
              <Tabs.Item
                name="devolution"
                active={selectedTab === 'Devolução'}
                onClick={() => setSelectedTab('Devolução')}
              >
                Devolução
              </Tabs.Item>
            )}
            <Tabs.Item
              name="invoiceQRcode"
              active={selectedTab === 'QR Code da nota'}
              onClick={() => setSelectedTab('QR Code da nota')}
            >
              QR Code da Nota
            </Tabs.Item>
            <Tabs.Item
              name="expenses"
              active={selectedTab === 'Despesas'}
              onClick={() => setSelectedTab('Despesas')}
            >
              Despesas
            </Tabs.Item>
            {invoice.return && (
              <Tabs.Item
                name="return"
                active={selectedTab === 'Rejeição'}
                onClick={() => setSelectedTab('Rejeição')}
              >
                Rejeição
              </Tabs.Item>
            )}
            {invoice.incidents && invoice.incidents.length > 0 && (
              <Tabs.Item
                name="incidents"
                active={selectedTab === 'Incidentes'}
                onClick={() => setSelectedTab('Incidentes')}
              >
                Incidentes
              </Tabs.Item>
            )}
          </Tabs>
        </div>
        {renderPanel(selectedTab)}
      </Modal>
      <Load active={isFetchInvoice} />
    </>
  );
};

function mapStateToProps({ invoice }) {
  const { dataObject, isFetchInvoice } = invoice;

  return {
    dataObject,
    isFetchInvoice,
  };
}

export default connect(mapStateToProps)(InvoiceDetail);
